/** @format */
import React from 'react';
import {
    CARTON_BRIGHT_WHITE_PAPER,
    CARTON_HOLOGRAPHIC,
    CARTON_METALLIC_PAPER,
    CARTON_WHITE_PAPER,
    CARTON_WHITE_PAPER_C2S,
    COLOR_BLACK_ONLY,
    COLOR_CAPATIBILITY_MATRIX,
    COLOR_WHITE_ONLY,
    DUPLEX_SUBSTRATES,
    PRODUCT_TYPE_CARTON
} from 'frontier-constants';
import {Checkbox, Icon, IconButton, Select, Tooltip} from '@sttark/design-system';
import {ConditionalButton, IfElse} from 'frontier-utilities';
import {useContext} from 'react';
import QuoteContext from 'frontier/quoter/components/quote_context';

export default function DuplexFrontBackOption(props) {
    const {order, ...ctx} = useContext(QuoteContext);
    // Also in AdditionalOptions
    const canBlackInkOnly = COLOR_CAPATIBILITY_MATRIX[COLOR_BLACK_ONLY].includes(
        order.substrate_id
    );
    // Also in AdditionalOptions
    const canWhiteInkOnly = COLOR_CAPATIBILITY_MATRIX[COLOR_WHITE_ONLY].includes(
        order.substrate_id
    );
    const duplexOptions = [{label: 'Full Color', value: order.color_id}];

    // Visually, carton bright white paper is allowed, but choosing duplex will auto switch to the C2S version
    const canDuplex = DUPLEX_SUBSTRATES.includes(parseInt(order.substrate_id)) && !order.is_blank;

    if (canBlackInkOnly) {
        duplexOptions.push({
            label: 'Black Only',
            value: COLOR_BLACK_ONLY
        });
    }

    if (canWhiteInkOnly) {
        duplexOptions.push({label: 'White Only', value: COLOR_WHITE_ONLY});
    }

    return (
        <ConditionalButton enabled={order.product_type_id === PRODUCT_TYPE_CARTON}>
            <>
                {canDuplex && (
                    <Checkbox
                        disabled={!canDuplex}
                        checked={order.is_duplex}
                        onChange={() => {
                            const changeTarget = {
                                order: {
                                    is_duplex: {$set: !order.is_duplex},
                                    duplex_color_id: {
                                        $set: order.is_duplex ? null : order.color_id
                                    }
                                }
                            };
                            ctx.handleChange(changeTarget);
                        }}>
                        Duplex Print (upload artwork for inside and outside of the carton)
                        <Tooltip content="Print on the inside of the box as well as the outside. Not compatible with Metallic or Rainbow Holographic material.">
                            <IconButton secondary small icon="info" />
                        </Tooltip>
                    </Checkbox>
                )}
                {!canDuplex && (
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <Icon name={'warning'} color="#df3d33" />
                        <div style={{marginLeft: '5px'}}>
                            <IfElse condition={order.is_blank}>
                                <>Duplex is not available for blank cartons</>
                                <>Duplex is not available for {order.substrate_label}</>
                            </IfElse>
                        </div>
                    </div>
                )}
                {order.is_duplex && (
                    <>
                        <h6>Duplex Printing Color (applies to all)</h6>
                        <Select
                            placeholder="Select a color mode for inside the carton"
                            name="duplex_color_id"
                            label={null}
                            options={duplexOptions}
                            value={order.duplex_color_id}
                            onChange={color_id =>
                                ctx.handleChange({order: {duplex_color_id: {$set: color_id}}})
                            }
                        />
                    </>
                )}
            </>
            <Checkbox
                disabled={order.is_blank}
                checked={order.is_front_back}
                onChange={() =>
                    ctx.handleChange({
                        order: {
                            is_front_back: {$set: !order.is_front_back}
                        }
                    })
                }>
                Front/Back Alternating
                <Tooltip content="Front and back label designs will be organized on the same roll in an alternating pattern for easier application.">
                    <IconButton secondary small icon="info" />
                </Tooltip>
            </Checkbox>
        </ConditionalButton>
    );
}
